import PropTypes from 'prop-types';
import Flux from '../../flux/Flux';
import VXButton from '../SimpleElements/VXButton/VXButton';
import { COLOR_TYPE_SPECIAL } from '../SimpleElements/VXButton/ButtonHelper';
import { VXButtonLineConfig } from '../SimpleElements/VXButton/VXButtonConfig';
import STYLES from '../SimpleElements/VXButton/EnumVXButton';
import { getCommonTranslation } from '../../utils/TranslationHelper';
import { Fragment, PureComponent } from 'react';

class FeedPostCommentMenuDelete extends PureComponent {
	constructor(props) {
		super(props);
		this.deleteComment = this.deleteComment.bind(this);
	}

	deleteComment() {
		Flux.Feed.deleteComment(this.props.commentId, (resp) => {
			if (!resp.error) {
				this.props.setType(this.props.types.DELETED);
			}
		});
	}

	getDeletedBadge() {
		const content = (
			<Fragment>
				<i className="icon -icon-success-rounded-full"></i>
				{getCommonTranslation('comment-deleted')}
			</Fragment>
		);
		return this.props.getBadge({ content });
	}

	getDeleteFlow() {
		const content = <div className="feed__comment-tour__modal-text">{getCommonTranslation('confirm-comment-delete')}</div>;
		const button = (
			<VXButton
				color={COLOR_TYPE_SPECIAL}
				line1={[new VXButtonLineConfig(getCommonTranslation('delete'))]}
				onClick={this.deleteComment}
				size={STYLES.SIZE.SMALL}
			/>
		);
		return this.props.getModal({ full: true, title: getCommonTranslation('delete-comment'), content, button });
	}

	render() {
		if (this.props.type === this.props.types.DELETE) {
			return this.getDeleteFlow();
		} else if (this.props.type === this.props.types.DELETED) {
			return this.getDeletedBadge();
		}
	}
}

FeedPostCommentMenuDelete.propTypes = {
	type: PropTypes.string.isRequired,
	types: PropTypes.object.isRequired,
	commentId: PropTypes.string.isRequired,
	setType: PropTypes.func.isRequired,
	getBadge: PropTypes.func.isRequired,
	getModal: PropTypes.func.isRequired,
};

export default FeedPostCommentMenuDelete;
